import { render } from "./MarqueeRow.vue?vue&type=template&id=e8f2caf0&scoped=true"
import script from "./MarqueeRow.vue?vue&type=script&lang=js"
export * from "./MarqueeRow.vue?vue&type=script&lang=js"

import "./MarqueeRow.vue?vue&type=style&index=0&id=e8f2caf0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8f2caf0"]])

export default __exports__